import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { Plane, MapPin, Clock } from 'lucide-react';

const ZaventemCentreBruxelles = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Zaventem Centre Bruxelles | Taxi Aéroport - Ville</title>
        <meta name="description" content="Transfert Zaventem Centre Bruxelles. Taxi privé aéroport-ville, 20 min, prix fixe. Service porte-à-porte 24/7. Réservation instantanée." />
        <meta name="keywords" content="zaventem centre bruxelles, taxi zaventem bruxelles, transfert aeroport zaventem, navette zaventem" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/zaventem-centre-bruxelles" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
            Zaventem ↔ Centre Bruxelles
          </h1>
          <p className="text-xl text-gray-300 text-center mb-8">
            Transfert privé aéroport Zaventem - Centre-ville Bruxelles. 20 min, prix fixe garanti.
          </p>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection defaultPickup="Aéroport Zaventem" defaultDropoff="Centre Bruxelles" />
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Transfert Aéroport Zaventem - Bruxelles Centre</h2>
          <p className="text-gray-300 mb-4">
            <strong>Route la plus demandée</strong> : Aéroport Zaventem ↔ Centre-ville Bruxelles. Seulement 20 minutes, 
            prix fixe sans surprise. Suivi de vol, accueil personnalisé, aide aux bagages incluse. Service 24/7.
          </p>
          <div className="bg-gray-800 p-6 rounded-lg mt-6">
            <h3 className="text-xl font-bold text-gold mb-4">✨ Inclus dans le Service</h3>
            <ul className="text-gray-300 space-y-2">
              <li>✅ Suivi de vol en temps réel</li>
              <li>✅ Accueil avec panneau nominatif</li>
              <li>✅ Aide aux bagages</li>
              <li>✅ Eau & journaux à bord</li>
              <li>✅ Wifi gratuit</li>
              <li>✅ Tarif fixe (pas de supplément trafic/nuit)</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ZaventemCentreBruxelles;